import React from "react"
import classnames from "classnames"
import { Input, ShowIcon, HideIcon, A } from "AtomicComponents"
import styles from "./InputPassword.less"

class InputPassword extends React.PureComponent {
  constructor(props) {
    super(props)

    this.state = {
      isVisible: false
    }
  }

  _onBlurHandler = () => {
    const { onBlur = () => { } } = this.props
    onBlur()
  }

  _onChangeHandler = (value) => {
    const { onChange = () => { } } = this.props
    onChange(value)
  }

  _getThisInput = (inputThis) => {
    const { getThisInput = () => { } } = this.props
    this.input = inputThis
    getThisInput(inputThis)
  }

  _handleOnClick = () => {
    this.setState(prevState => ({
      isVisible: !prevState.isVisible
    }))
  }

  render() {
    const { label, name, required, isValid, message, defaultValue } = this.props
    const { isVisible } = this.state

    return (
      <div className={classnames({
        [styles.InputPassword]: true
      })}>
        <Input
          label={label}
          getThisInput={this._getThisInput}
          name={name}
          type={isVisible ? 'text' : 'password'}
          required={required}
          defaultValue={defaultValue}
          isValid={isValid}
          message={message}
          onChange={this._onChangeHandler}
          onBlur={this._onBlurHandler}
        />
        <div className={classnames({
          [styles.InputPasswordIcon]: true,
          [styles.InputPasswordIconInnerInvalid]: !isValid && message
        })}>
          <A withoutStyle styleName="black" onClick={this._handleOnClick}>
            {
              isVisible ?
              <HideIcon style={{
                width: "22px",
                height: "22px"
              }} />
              :
              <ShowIcon style={{
                width: "22px",
                height: "22px"
              }} />
            }
          </A>
        </div>
      </div>
    )
  }
}


export default InputPassword



// WEBPACK FOOTER //
// ./src/AtomicComponents/InputPassword/InputPassword.jsx